import { useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import { __ } from '@wordpress/i18n';

import {
	__experimentalInputControl as InputControl,
	__experimentalGrid as Grid,
	SelectControl,
	Button,
	Snackbar,
  TabPanel
} from '@wordpress/components';

import TabGeneral from './tab_general';
import TabAdvanced from './tab_advanced';

const Tabs = ( props ) => {

	return (
		<>
			<div className="re-esp-settings-form">
        <TabPanel
          className="re-esp-settings-tabs"
          activeClass="active-tab"
          tabs={ [
            {
              name: 'general',
              title: __( 'General', 're-ESP' ),
              className: 're-esp-settings-tab-general',
            },
            {
              name: 'advanced',
              title: __( 'Advanced Settings', 're-ESP' ),
              className: 're-esp-settings-tab-advanced',
            },
          ] }
        >
          { ( tab ) => {
            if ( tab.name === 'general' ) {
              return (
                <div className="re-esp-settings-tab-general">
                  <TabGeneral />
                </div>
              );
            }

            if ( tab.name === 'advanced' ) {
              return (
                <div className="re-esp-settings-tab-advanced">
                  <TabAdvanced />
                </div>
              );
            }
          } }
        </TabPanel>


			</div>
		</>
	);
};

export default Tabs;
